import React from 'react';

const iconShapes = {
  '3drotate_x': {
    shape: (
      <path d="M12.08,1.85C9.36,1.85,7.23,5.24,6.76,10L3.69,10l4.13,5.13L12,10,8.78,10c.42-3.62,1.93-6.13,3.3-6.13,1.61,0,3.42,3.48,3.42,8.13s-1.8,8.13-3.42,8.13c-.57,0-1.26-.18-2-1.53a1,1,0,1,0-1.76.94,4.19,4.19,0,0,0,3.74,2.58c3.09,0,5.42-4.36,5.42-10.13S15.17,1.85,12.08,1.85Z" />
    ),
  },
  '3drotate_y': {
    shape: (
      <path d="M12,6.58C6.22,6.58,1.86,8.91,1.86,12c0,2.72,3.39,4.85,8.16,5.32l0,3.07,5.13-4.13L10,12l0,3.25c-3.62-.42-6.13-1.93-6.13-3.3,0-1.61,3.48-3.42,8.13-3.42s8.13,1.8,8.13,3.42c0,.57-.18,1.26-1.53,2a1,1,0,0,0,.94,1.76A4.19,4.19,0,0,0,22.13,12C22.13,8.91,17.77,6.58,12,6.58Z" />
    ),
  },
  account: {
    shape: (
      <g>
        <path d="M12,12.92c2.6,0,4.61-3,4.61-5.84S15.15,2,12,2,7.37,4.25,7.37,7.08,9.39,12.92,12,12.92Z" />
        <path d="M12,15.54c-5.31,0-9.65-4.2-9.93,5.41a1,1,0,0,0,1,1H20.92a1,1,0,0,0,1-1C21.63,11.37,17.29,15.54,12,15.54Z" />
      </g>
    ),
  },
  add_to_course: {
    shape: (
      <g>
        <path d="M3,5 L3,3 L21,3 L21,5 L3,5 Z M3,10 L3,8 L21,8 L21,10 L3,10 Z M3,15 L3,13 L11,13 L11,15 L3,15 Z M3,20 L3,18 L11,18 L11,20 L3,20 Z M16,16 L16,13 L18,13 L18,16 L21,16 L21,18 L18,18 L18,21 L16,21 L16,18 L13,18 L13,16 L16,16 Z" />
      </g>
    ),
  },
  alert_outline: {
    shape: (
      <g>
        <rect x="11" y="10" width="2" height="4" />
        <rect x="11" y="15" width="2" height="2" />
        <path d="M21.71,19.13,13.06,3.85A1.31,1.31,0,0,0,12,3.08a1.31,1.31,0,0,0-1.08.77L2.26,19.13c-.59,1-.11,1.87,1.08,1.87H20.63C21.82,21,22.3,20.15,21.71,19.13ZM4.63,19,12,6l7.35,13Z" />
      </g>
    ),
  },
  alert: {
    shape: (
      <path d="M21.71,19.13,13.06,3.85a1.14,1.14,0,0,0-2.16,0L2.26,19.13c-.59,1-.11,1.87,1.08,1.87H20.63C21.82,21,22.3,20.15,21.71,19.13ZM13,17H11V15h2Zm0-3H11V10h2Z" />
    ),
  },
  arrow_left: {
    shape: (
      <polygon points="21 11 5.84 11 13.33 3.52 11.92 2.1 3.43 10.59 3.43 10.59 2.02 12 3.43 13.41 11.92 21.9 13.33 20.48 5.84 13 21 13 21 11" />
    ),
  },
  arrow_right: {
    shape: (
      <polygon points="3.02 11 18.17 11 10.68 3.52 12.1 2.1 20.58 10.59 20.58 10.59 22 12 20.58 13.41 12.1 21.9 10.68 20.48 18.17 13 3.02 13 3.02 11" />
    ),
  },
  bar_chart: {
    shape: (
      <g>
        <rect x="16" y="3" width="4" height="18" />
        <rect x="10" y="9" width="4" height="12" />
        <rect x="4" y="14" width="4" height="7" />
      </g>
    ),
  },
  blank_document: {
    shape: (
      <g>
        <path d="M13.8258 2L19.792 8.36396L18.4662 9.77817L12.5 3.41421L13.8258 2Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.9375 2H13.7396L15.6146 4H14.375V8L18.125 8V6.67773L20 8.67773V21C20 21.553 19.5809 22 19.0625 22H5.9375C5.42 22 5 21.553 5 21V3C5 2.447 5.42 2 5.9375 2ZM18.125 10L13.4375 10C12.9197 10 12.5 9.55228 12.5 9V4H6.875V20H18.125V10Z"
        />
      </g>
    ),
  },
  book: {
    shape: (
      <g>
        <path d="M7,2H5.05A1,1,0,0,0,4,3V21a1,1,0,0,0,1.05,1H7Z" />
        <g>
          <rect x="11" y="7" width="6" height="2" />
          <path d="M20,2H8V22H20Zm-2,8H10V6h8Z" />
        </g>
      </g>
    ),
  },
  bookmark_outline: {
    shape: (
      <path d="M17,2H6.94A1,1,0,0,0,6,3V22l6-3,6,3V3A1,1,0,0,0,17,2ZM16,18.74l-3.1-1.55L12,16.74l-.86.44L8,18.76V4h8Z" />
    ),
  },
  bookmark: {
    shape: (
      <path
        d="M17,2H6.94A1,1,0,0,0,6,3V22l6-3,6,3V3A1,1,0,0,0,17,2Z"
        fillRule="evenodd"
      />
    ),
  },
  box: {
    shape: <path d="M4,20H20V9H4Zm4-8h8v2H8ZM3,4V8H21V4Z" fillRule="evenodd" />,
  },
  calc_longarrow_dual: {
    shape: (
      <g>
        <path d="M21.92,10.38a1,1,0,0,0-.21-1.09l-5-5L15.29,5.71,18.59,9H2v2H21A1,1,0,0,0,21.92,10.38Z" />
        <path d="M22,13H3a1,1,0,0,0-.92.62,1,1,0,0,0,.21,1.09l5,5,1.42-1.42L5.41,15H22Z" />
      </g>
    ),
  },
  calendar_open: {
    shape: (
      <path d="M20,4H18V2H16V4H8V2H6V4H4A1,1,0,0,0,3,5V21a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V5A1,1,0,0,0,20,4ZM5,20V10H19V20Z" />
    ),
  },
  calendar: {
    shape: (
      <g>
        <path d="M20,4H18V2H16V4H8V2H6V4H4A1,1,0,0,0,3,5V21a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V5A1,1,0,0,0,20,4ZM5,20V10H19V20Z" />
        <rect x="7" y="12" width="2" height="2" />
        <rect x="11" y="12" width="2" height="2" />
        <rect x="15" y="12" width="2" height="2" />
        <rect x="15" y="16" width="2" height="2" />
        <rect x="11" y="16" width="2" height="2" />
        <rect x="7" y="16" width="2" height="2" />
      </g>
    ),
  },
  calendar_plus: {
    shape: (
      <g>
        <path
          d="M11.2787089,11.9509963 L11.2836409,14.54028 L8.69435718,14.5353481 L8.69435718,15.9360273 L11.2836409,15.9310953 L11.2787089,18.520379 L12.6793881,18.520379 L12.6744562,15.9310953 L15.2637399,15.9360273 L15.2637399,14.5353481 L12.6744562,14.54028 L12.6793881,11.9509963 L11.2787089,11.9509963 Z M20,4 L18,4 L18,2 L16,2 L16,4 L8,4 L8,2 L6,2 L6,4 L4,4 C3.44771525,4 3,4.44771525 3,5 L3,21 C3,21.5522847 3.44771525,22 4,22 L20,22 C20.5522847,22 21,21.5522847 21,21 L21,5 C21,4.44771525 20.5522847,4 20,4 Z M5,20 L5,10 L19,10 L19,20 L5,20 Z"
          id="path-1"
        />
      </g>
    ),
  },
  caret_down: {
    shape: <polygon points="2 6 12.02 18.02 22.04 6 2 6" fillRule="evenodd" />,
  },
  caret_up: {
    shape: (
      <polygon
        points="2 6 12.02 18.02 22.04 6 2 6"
        transform="rotate(-180 12.020000457763672,12.010000228881836)"
        fillRule="evenodd"
      />
    ),
  },
  caret_right: {
    shape: (
      <polygon
        points="2 6 12.02 18.02 22.04 6 2 6"
        transform="rotate(-90 12.020000457763672,12.010000228881836)"
        fillRule="evenodd"
      />
    ),
  },
  check: {
    shape: (
      <polygon points="8.42 17.96 21 5.83 19.59 4.42 7.81 15.77 3.44 11.4 2.02 12.81 6.37 17.16 6.36 17.17 7.77 18.58 7.78 18.57 7.79 18.58 8.42 17.96" />
    ),
  },
  checkbox: {
    shape: (
      <g>
        <polygon points="8.36 15.17 9.77 16.58 9.78 16.57 9.79 16.58 10.17 16.2 18 8.83 16.59 7.42 9.82 13.79 7.44 11.4 6.02 12.81 8.37 15.16 8.36 15.17" />
        <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H5V5H19Z" />
      </g>
    ),
  },
  chevron_double_down: {
    shape: (
      <g>
        <polygon points="20.77 10.34 12.28 18.83 3.8 10.34 2.38 11.76 12.28 21.66 13.7 20.24 22.18 11.76 20.77 10.34" />
        <polygon points="20.77 2.34 12.28 10.83 3.8 2.34 2.38 3.76 12.28 13.66 13.7 12.24 22.18 3.76 20.77 2.34" />
      </g>
    ),
  },
  chevron_double_up: {
    shape: (
      <g>
        <polygon points="3.8 13.66 12.28 5.17 20.77 13.66 22.18 12.24 12.28 2.34 10.87 3.76 2.38 12.24 3.8 13.66" />
        <polygon points="3.8 21.66 12.28 13.17 20.77 21.66 22.18 20.24 12.28 10.34 10.87 11.76 2.38 20.24 3.8 21.66" />
      </g>
    ),
  },
  chevron_down: {
    shape: (
      <polygon points="20.47 6.34 11.98 14.83 3.5 6.34 2.08 7.76 11.98 17.66 13.4 16.24 21.88 7.76 20.47 6.34" />
    ),
  },
  chevron_left: {
    shape: (
      <polygon points="17.27 3.52 15.86 2.1 7.38 10.59 7.38 10.59 5.96 12 7.38 13.41 15.86 21.9 17.27 20.48 8.79 12 17.27 3.52" />
    ),
  },
  chevron_right: {
    shape: (
      <polygon points="16.48 10.59 16.48 10.59 8 2.1 6.59 3.52 15.07 12 6.59 20.48 8 21.9 16.48 13.41 17.9 12 16.48 10.59" />
    ),
  },
  chevron_up: {
    shape: (
      <polygon points="12 6.34 10.59 7.76 2.1 16.24 3.52 17.66 12 9.17 20.48 17.66 21.9 16.24 12 6.34" />
    ),
  },
  child: {
    shape: (
      <polygon
        id="Rectangle-9-Copy"
        fill="#080808"
        points="13 8 19 13 13 18 13 14 4 14 4 5 6 5 6 12 13 12"
      />
    ),
  },
  circle_half_filled: {
    defs: (
      <clipPath id="svg_circle_half_filled">
        <path d="M10,0 C15.523,0 20,4.478 20,10 C20,15.522 15.523,20 10,20 C4.477,20 0,15.522 0,10 C0,4.478 4.477,0 10,0 Z M10,2 L10,18 C14.418,18 18,14.418 18,10 C18,5.582 14.418,2 10,2 C8.87001969,2 8.92092752,2 10,2 Z" />
      </clipPath>
    ),
    shape: (
      <g
        clipPath="url(#svg_circle_half_filled)"
        transform="translate(5.33 5.33)"
      >
        <path d="M10,0 C15.523,0 20,4.478 20,10 C20,15.522 15.523,20 10,20 C4.477,20 0,15.522 0,10 C0,4.478 4.477,0 10,0 Z M10,2 L10,18 C14.418,18 18,14.418 18,10 C18,5.582 14.418,2 10,2 C8.87001969,2 8.92092752,2 10,2 Z" />
      </g>
    ),
    viewBox: '0 0 34.58 34.58',
  },
  circle_check_filled: {
    defs: (
      <g>
        <clipPath
          id="svg_circle_check_filled_clip_a"
          transform="translate(5.19 5.32)"
        >
          <circle cx="12.06" cy="11.94" r="10.02" />
        </clipPath>
        <clipPath
          id="svg_circle_check_filled_clip_b"
          transform="translate(5.19 5.32)"
        >
          <path
            clipRule="evenodd"
            fill="none"
            d="M10.87 13.32l-2.4-2.41-1.42 1.43 2.36 2.34-.01.01 1.41 1.43.01-.01.01.01.33-.33 6.89-6.45-1.41-1.41-5.77 5.39z"
          />
        </clipPath>
      </g>
    ),
    shape: (
      <g>
        <g clipPath="url(#svg_circle_check_filled_clip_a)">
          <path className="circle_fill" d="M2 2h30.5v30.5H2z" />
        </g>
        <g clipPath="url(#svg_circle_check_filled_clip_b)">
          <path fill="#fff" d="M7.01 8.02h21.46v18.64H7.01z" />
        </g>
      </g>
    ),
    viewBox: '0 0 34.51 34.51',
  },
  circle_check_outline: {
    shape: (
      <g>
        <polygon points="10.34 13.88 7.95 11.48 6.53 12.9 8.88 15.24 8.87 15.25 10.28 16.67 10.29 16.66 10.3 16.67 10.63 16.34 17.51 9.91 16.1 8.5 10.34 13.88" />
        <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
      </g>
    ),
  },
  circle_empty: {
    defs: (
      <clipPath id="svg_circle_empty_clip_a" transform="translate(5.33 5.33)">
        <path
          d="M12 1.92A10 10 0 1 0 22 12 10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8"
          fill="none"
        />
      </clipPath>
    ),
    shape: (
      <g clipPath="url(#svg_circle_empty_clip_a)">
        <path d="M0 0h34.58v34.58H0z" />
      </g>
    ),
    viewBox: '0 0 34.58 34.58',
  },
  circle_x_filled: {
    defs: (
      <g>
        <clipPath
          id="svg_circle_x_filled_clip_a"
          transform="translate(5.33 5.33)"
        >
          <circle cx="11.96" cy="11.96" r="10.04" />
        </clipPath>
        <clipPath
          id="svg_circle_x_filled_clip_b"
          transform="translate(5.33 5.33)"
        >
          <path
            clipRule="evenodd"
            fill="none"
            d="M15.89 6.94l-3.93 3.93-3.93-3.93-1.09 1.09 3.93 3.93-3.93 3.93 1.09 1.09 3.93-3.93 3.93 3.93 1.09-1.09-3.93-3.93 3.93-3.93-1.09-1.09z"
          />
        </clipPath>
      </g>
    ),
    shape: (
      <g>
        <g clipPath="url(#svg_circle_x_filled_clip_a)">
          <path className="circle_fill" d="M2.01 2.01h30.56v30.56H2.01z" />
        </g>
        <g clipPath="url(#svg_circle_x_filled_clip_b)">
          <path fill="#fff" d="M7.03 7.03h20.52v20.52H7.03z" />
        </g>
      </g>
    ),
    viewBox: '0 0 34.58 34.58',
  },
  clipboard: {
    shape: (
      <path
        d="M18.94,4H14.53A2.5,2.5,0,0,0,12,1.54,2.46,2.46,0,0,0,9.47,4H4.94a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1h14a1,1,0,0,0,1-1V5A1,1,0,0,0,18.94,4ZM12,3a1,1,0,1,1-1,1A1,1,0,0,1,12,3Zm6,17h-12V6H8a.94.94,0,0,0,0,.1V7A1,1,0,0,0,9,8h6a1,1,0,0,0,1-1V6h1.94Z"
        fillRule="evenodd"
      />
    ),
  },
  clock: {
    shape: (
      <g>
        <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
        <polygon points="13.04 11 13.04 6 11.04 6 11.04 11 11.04 13 13.04 13 18.04 13 18.04 11 13.04 11" />
      </g>
    ),
  },
  collapse: {
    shape: (
      <g>
        <polygon
          points="21.04 4.41 19.63 3 15.99 6.64 13.04 3.75 13.04 11 20.42 11 17.41 8.04 21.04 4.41"
          fill="#231f20"
          fillRule="evenodd"
        />
        <polygon
          points="6.67 15.96 3.04 19.59 4.46 21 8.1 17.36 11.04 20.25 11.04 13 3.66 13 6.67 15.96"
          fill="#231f20"
          fillRule="evenodd"
        />
      </g>
    ),
  },
  comment_highlight: {
    shape: (
      <g>
        <path
          d="M17,16H10.24l-.54.45L8,17.82V16H4V6h9l2-2H3A1,1,0,0,0,2,5V17a1,1,0,0,0,1,1H6v4l4.94-4H18a1,1,0,0,0,1-1V12l-2,2.13Z"
          fillRule="evenodd"
        />
        <path
          d="M22.43,3.73,21.26,2.54a.69.69,0,0,0-1,0l-1,1,2.08,2.17,1.05-1A.69.69,0,0,0,22.43,3.73Z"
          fillRule="evenodd"
        />
        <polygon
          points="12.93 9.96 12.93 12.06 14.99 12.06 20.68 6.38 18.58 4.21 12.93 9.96"
          fillRule="evenodd"
        />
        <rect x="6" y="13" width="9" height="1" />
      </g>
    ),
  },
  comment_microphone: {
    shape: (
      <g>
        <path d="M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z" />
        <g>
          <rect
            x="10.57"
            y="5.49"
            width="2.83"
            height="5.52"
            rx="1.41"
            ry="1.41"
          />
          <path d="M15.48,9.53a.5.5,0,0,0-1,0,2.49,2.49,0,1,1-5,0,.5.5,0,0,0-1,0,3.51,3.51,0,0,0,3,3.47v1a.5.5,0,0,0,1,0V13A3.51,3.51,0,0,0,15.48,9.53Z" />
        </g>
      </g>
    ),
  },
  comment_question: {
    shape: (
      <g>
        <path d="M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z" />
        <path d="M11,8.08a1.35,1.35,0,0,1,.21-.45,1,1,0,0,1,.35-.31A1.08,1.08,0,0,1,12,7.2a1,1,0,0,1,.69.24A1,1,0,0,1,13,8.2a.91.91,0,0,1-.11.5,1.49,1.49,0,0,1-.3.37l-.41.33a2.8,2.8,0,0,0-.42.39A2.21,2.21,0,0,0,11.21,11v.6h1.45l0-.52a1.28,1.28,0,0,1,.22-.45,2.14,2.14,0,0,1,.39-.39l.47-.34a2.3,2.3,0,0,0,.45-.42,2.14,2.14,0,0,0,.34-.59A2.37,2.37,0,0,0,14.72,8a2,2,0,0,0-.14-.69,1.92,1.92,0,0,0-.46-.69,2.55,2.55,0,0,0-.85-.54A3.47,3.47,0,0,0,12,5.91a2.84,2.84,0,0,0-1.1.21,2.44,2.44,0,0,0-.84.57,2.61,2.61,0,0,0-.54.86,3.17,3.17,0,0,0-.2,1.1H10.9A2.25,2.25,0,0,1,11,8.08Z" />
        <rect x="11.16" y="12.45" width="1.54" height="1.56" />
      </g>
    ),
  },
  comment_text: {
    shape: (
      <g>
        <path d="M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z" />
        <rect x="7" y="7" width="10" height="2" />
        <rect x="7" y="11" width="6" height="2" />
      </g>
    ),
  },
  comment_thumbs_up: {
    shape: (
      <g>
        <path d="M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z" />
        <g>
          <path d="M16.52,9.05a.45.45,0,0,0-.45-.51H12.85s.46-1.27.73-2.08-.1-1.33-.59-.84L10.23,8.39a.77.77,0,0,0-.23.56v4.44a.17.17,0,0,0,.17.17H15a.79.79,0,0,0,.73-.48s.84-3,.84-3.08Z" />
          <rect x="7.47" y="8.56" width="1.48" height="4.98" />
        </g>
      </g>
    ),
  },
  comment: {
    shape: (
      <path d="M20,2H4A1,1,0,0,0,3,3V17a1,1,0,0,0,1,1H7v4l4.94-4H20a1,1,0,0,0,1-1V3A1,1,0,0,0,20,2ZM19,16H11.24l-.54.45L9,17.82V16H5V4H19Z" />
    ),
  },
  crown: {
    shape: (
      <path d="M4.64 16.5a.5.5 0 01-.492-.412L2.105 4.71a.2.2 0 01.332-.182l5.49 5.053a.2.2 0 00.309-.048l3.59-6.232a.2.2 0 01.347 0l3.591 6.232a.2.2 0 00.309.048l5.49-5.053a.2.2 0 01.332.182l-2.043 11.378a.5.5 0 01-.492.412H4.64zm15.138 3.375c0 .675-.445 1.125-1.111 1.125H5.333c-.666 0-1.11-.45-1.11-1.125V18.75h15.555v1.125z" />
    ),
  },
  cursor: {
    shape: (
      <path
        d="M3,13V4A1,1,0,0,1,4,3H20a1,1,0,0,1,1,1v9l-9,7Z"
        fillRule="evenodd"
      />
    ),
  },
  dock_left: {
    shape: (
      <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H9V5H19Z" />
    ),
  },
  dock_right: {
    shape: (
      <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM5,5H15V19H5Z" />
    ),
  },
  dock_top: {
    shape: (
      <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM5,19V9H19V19Z" />
    ),
  },
  document: {
    shape: (
      <g>
        <path d="M19,2H5A1,1,0,0,0,4,3V21a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1ZM6,20V4H18V20Z" />
        <polygon points="16 7 8 7 8 9 16 9 16 7 16 7" />
        <polygon points="16 11 8 11 8 13 16 13 16 11 16 11" />
        <polygon points="14 15 8 15 8 17 14 17 14 15 14 15" />
      </g>
    ),
  },
  download: {
    shape: (
      <g>
        <polygon
          points="19 14 19 18 5 18 5 14 3 14 3 18 3 20 5.5 20 19.5 20 21 20 21 18 21 14 19 14"
          fillRule="evenodd"
        />
        <polygon
          points="12 15 16 11 13 11 13 4 11 4 11 11 8 11 12 15"
          fillRule="evenodd"
        />
      </g>
    ),
  },
  dots_vertical: {
    shape: (
      <path d="M9 12C9.39782 12 9.77936 12.158 10.0607 12.4393C10.342 12.7206 10.5 13.1022 10.5 13.5C10.5 13.8978 10.342 14.2794 10.0607 14.5607C9.77936 14.842 9.39782 15 9 15C8.60218 15 8.22064 14.842 7.93934 14.5607C7.65804 14.2794 7.5 13.8978 7.5 13.5C7.5 13.1022 7.65804 12.7206 7.93934 12.4393C8.22064 12.158 8.60218 12 9 12ZM9 7.5C9.39782 7.5 9.77936 7.65804 10.0607 7.93934C10.342 8.22064 10.5 8.60218 10.5 9C10.5 9.39782 10.342 9.77936 10.0607 10.0607C9.77936 10.342 9.39782 10.5 9 10.5C8.60218 10.5 8.22064 10.342 7.93934 10.0607C7.65804 9.77936 7.5 9.39782 7.5 9C7.5 8.60218 7.65804 8.22064 7.93934 7.93934C8.22064 7.65804 8.60218 7.5 9 7.5ZM9 3C9.39782 3 9.77936 3.15804 10.0607 3.43934C10.342 3.72064 10.5 4.10218 10.5 4.5C10.5 4.89782 10.342 5.27936 10.0607 5.56066C9.77936 5.84196 9.39782 6 9 6C8.60218 6 8.22064 5.84196 7.93934 5.56066C7.65804 5.27936 7.5 4.89782 7.5 4.5C7.5 4.10218 7.65804 3.72064 7.93934 3.43934C8.22064 3.15804 8.60218 3 9 3Z" />
    ),
  },
  edit: {
    shape: (
      <g>
        <path
          d="M20.69,5,19,3.29a1,1,0,0,0-1.41,0L16.18,4.7l3,3.13,1.51-1.41A1,1,0,0,0,20.69,5Z"
          fillRule="evenodd"
        />
        <polygon
          points="3 17.98 3 21 5.97 21 18.17 8.82 15.14 5.68 3 17.98"
          fillRule="evenodd"
        />
      </g>
    ),
  },
  eraser: {
    shape: (
      <g>
        <polygon points="9.58 20.98 20.96 20.98 20.96 18.98 11.46 18.98 9.58 20.98" />
        <path d="M21.78,7.9,16.25,2.37a1.19,1.19,0,0,0-1.68,0L7.88,9.06,2.46,14.47a1.19,1.19,0,0,0,0,1.68L7.29,21h3.08l4.75-4.75,6.65-6.65A1.19,1.19,0,0,0,21.78,7.9ZM9.79,19H8.18L4.28,15.21l5-4.78L13.84,15Z" />
      </g>
    ),
  },
  expand: {
    shape: (
      <g>
        <path
          d="M19,19H5V5h6.92l-2-2H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V14l-2-2Z"
          fillRule="evenodd"
        />
        <polygon
          points="13.98 3 16.84 5.87 9.36 13.36 10.77 14.77 18.26 7.28 21 10.02 21 3 13.98 3"
          fillRule="evenodd"
        />
      </g>
    ),
  },
  flag: {
    shape: (
      <path d="M10.8657 2L10.8617 19.582C11.9787 19.809 12.8197 20.795 12.8197 21.979H7.92773C7.92773 20.818 8.73873 19.851 9.82373 19.601L9.86573 2H10.8657ZM15.7347 2.86849C16.081 2.70606 16.4275 2.54351 16.8812 2.4551C18.0512 2.2271 19.8492 3.3481 19.8492 3.3481V8.6421C19.8492 8.6421 18.0322 7.5361 16.8162 7.7691C16.3747 7.85402 16.0425 8.012 15.7093 8.17048C15.2146 8.40575 14.7177 8.6421 13.8572 8.6421C12.8212 8.6421 11.8652 7.7491 11.8652 7.7491V2.4551C11.8652 2.4551 12.8212 3.3481 13.8572 3.3481C14.7124 3.3481 15.2233 3.10843 15.7347 2.86849Z" />
    ),
  },
  folder: {
    shape: (
      <path d="M22,20H2V5A1,1,0,0,1,3,4h7a1.09,1.09,0,0,1,1,1V6H21a1,1,0,0,1,1,1Z" />
    ),
  },
  fullscreen: {
    shape: (
      <g>
        <polygon
          points="13.66 3 16.67 5.96 13.04 9.59 14.46 11 18.1 7.36 21.04 10.25 21.04 3 13.66 3"
          fillRule="evenodd"
        />
        <polygon
          points="9.63 13 5.99 16.64 3.04 13.75 3.04 21 10.42 21 7.41 18.04 11.04 14.41 9.63 13"
          fillRule="evenodd"
        />
        <polygon
          points="14.46 13 13.04 14.41 16.68 18.06 13.79 21 21.04 21 21.04 13.62 18.09 16.63 14.46 13"
          fillRule="evenodd"
        />
        <polygon
          points="10.29 3 3.04 3 3.04 10.38 6 7.37 9.63 11 11.04 9.59 7.4 5.94 10.29 3"
          fillRule="evenodd"
        />
      </g>
    ),
  },
  fullscreen_collapse: {
    shape: (
      <g>
        <polygon
          className="cls-1"
          points="21.41 4 20 2.59 16.95 5.64 14 2.75 14 10 21.38 10 18.37 7.04 21.41 4"
        />
        <polygon
          className="cls-1"
          points="5.63 16.96 2.58 20 4 21.41 7.06 18.36 10 21.25 10 14 2.62 14 5.63 16.96"
        />
        <polygon
          className="cls-1"
          points="20 21.41 21.41 20 18.36 16.95 21.25 14 14 14 14 21.38 16.96 18.37 20 21.41"
        />
        <polygon
          className="cls-1"
          points="7.04 5.63 4 2.58 2.58 4 5.64 7.06 2.75 10 10 10 10 2.62 7.04 5.63"
        />
      </g>
    ),
  },
  panel_collapsed: {
    shape: (
      <g>
        <polygon
          className="cls-1"
          points="21 4.41 19.59 3 15.95 6.64 13 3.75 13 11 20.38 11 17.37 8.04 21 4.41"
        />
        <polygon
          className="cls-1"
          points="6.63 15.96 3 19.59 4.42 21 8.06 17.36 11 20.25 11 13 3.62 13 6.63 15.96"
        />
      </g>
    ),
  },
  panel_expanded: {
    shape: (
      <g>
        <polygon
          className="cls-1"
          points="13.62 3 16.63 5.96 13 9.59 14.42 11 18.06 7.36 21 10.25 21 3 13.62 3"
        />
        <polygon
          className="cls-1"
          points="9.59 13 5.95 16.64 3 13.75 3 21 10.38 21 7.37 18.04 11 14.41 9.59 13"
        />
      </g>
    ),
  },
  grabber: {
    shape: (
      <g>
        <circle cx="14.03" cy="12" r="0.98" />
        <circle cx="14.03" cy="8" r="0.98" />
        <circle cx="14.03" cy="4" r="0.98" />
        <circle cx="14.03" cy="20" r="0.98" />
        <circle cx="14.03" cy="16" r="0.98" />
        <circle cx="10.03" cy="12" r="0.98" />
        <circle cx="10.03" cy="8" r="0.98" />
        <circle cx="10.03" cy="4" r="0.98" />
        <circle cx="10.03" cy="20" r="0.98" />
        <circle cx="10.03" cy="16" r="0.98" />
      </g>
    ),
  },
  gear: {
    shape: (
      <path
        d="M21,13V11l-2.23-.74A7,7,0,0,0,18,8.37l1-2.11-1.43-1.4L15.52,5.93a7,7,0,0,0-1.74-.71L13,3H11L10.3,5.23A7,7,0,0,0,8.41,6L6.3,5,4.9,6.43,6,8.52a7,7,0,0,0-.71,1.74L3,11v2l2.23.74a7,7,0,0,0,.8,1.89L5,17.75l1.43,1.4,2.08-1.08a7,7,0,0,0,1.74.71L11,21h2l.74-2.23a7,7,0,0,0,1.89-.8l2.11,1,1.4-1.43-1.08-2.08a7,7,0,0,0,.71-1.74Zm-9,2a3,3,0,1,1,3-3A3,3,0,0,1,12,15Z"
        fillRule="evenodd"
      />
    ),
  },
  grid_4: {
    shape: (
      <path
        d="M3,10h7V3H3ZM14,3v7h7V3ZM3,21h7V14H3Zm11,0h7V14H14Z"
        fillRule="evenodd"
      />
    ),
  },
  grid_9: {
    shape: (
      <g>
        <rect x="2" y="3" width="5" height="5" />
        <rect x="9" y="3" width="5" height="5" />
        <rect x="16" y="3" width="5" height="5" />
        <rect x="2" y="10" width="5" height="5" />
        <rect x="9" y="10" width="5" height="5" />
        <rect x="16" y="10" width="5" height="5" />
        <rect x="2" y="17" width="5" height="5" />
        <rect x="9" y="17" width="5" height="5" />
        <rect x="16" y="17" width="5" height="5" />
      </g>
    ),
  },
  head: {
    shape: (
      <path d="M20.6,13.32,19.07,11a1,1,0,0,1-.13-.8,6.14,6.14,0,0,0,.17-1.41C19.11,5,15.82,2,11.77,2S4.43,5,4.43,8.77c0,.12,0,.24,0,.36h0v0c0,3.27,2.14,5.75,2.6,8.46a22.13,22.13,0,0,1,0,3.3,1,1,0,0,0,1,1h4.67a1,1,0,0,0,1-1.14c-.2-2.15,2-.45,3.77-1,.84-.27,1.3-2.83,1.48-4.08a1,1,0,0,1,.77-.84l.19,0A1,1,0,0,0,20.6,13.32ZM16,8.23c-2.51,2.3-1.52,4.33-4.3,4.33s-5-1.94-5-4.33,2.26-4,5-4S17.79,6.62,16,8.23Z" />
    ),
  },
  heart_outline: {
    shape: (
      <path d="M16,4a5,5,0,0,0-4,2A5,5,0,0,0,3,9,4.52,4.52,0,0,0,4,11.9C4.61,12.66,12,20,12,20s7.32-7.14,8-8.11A4.54,4.54,0,0,0,21,9,5,5,0,0,0,16,4Zm2.42,6.71c-.41.53-3.36,3.5-6.4,6.49C8.91,14.09,5.85,11,5.49,10.61A2.59,2.59,0,0,1,5,9,3,3,0,0,1,8,6a3.5,3.5,0,0,1,2.4,1.23L12,9l1.61-1.77A3.51,3.51,0,0,1,16,6a3,3,0,0,1,3,3A2.54,2.54,0,0,1,18.43,10.71Z" />
    ),
  },
  heart: {
    shape: (
      <path d="M16,4a5,5,0,0,0-4,2A5,5,0,0,0,3,9,4.52,4.52,0,0,0,4,11.9C4.61,12.66,12,20,12,20s7.32-7.14,8-8.11A4.54,4.54,0,0,0,21,9,5,5,0,0,0,16,4Z" />
    ),
  },
  help_outline: {
    shape: (
      <g>
        <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
        <rect x="11.05" y="15.03" width="1.95" height="1.98" />
        <path d="M14.82,7.68A3.24,3.24,0,0,0,13.74,7a4.41,4.41,0,0,0-1.67-.27,3.61,3.61,0,0,0-1.4.26,3.11,3.11,0,0,0-1.07.72,3.31,3.31,0,0,0-.69,1.1,4,4,0,0,0-.26,1.39h2.07a2.86,2.86,0,0,1,.08-.71,1.72,1.72,0,0,1,.26-.58,1.31,1.31,0,0,1,.45-.39,1.37,1.37,0,0,1,.65-.15,1.21,1.21,0,0,1,.88.31,1.29,1.29,0,0,1,.32,1,1.15,1.15,0,0,1-.13.63,1.9,1.9,0,0,1-.39.46q-.24.21-.52.42a3.56,3.56,0,0,0-.53.5,2.81,2.81,0,0,0-.68,1.58V14H13l.06-.66a1.63,1.63,0,0,1,.28-.58,2.72,2.72,0,0,1,.5-.5l.6-.44a2.92,2.92,0,0,0,.58-.53,2.71,2.71,0,0,0,.44-.75,3,3,0,0,0,.18-1.11,2.54,2.54,0,0,0-.18-.88A2.44,2.44,0,0,0,14.82,7.68Z" />
      </g>
    ),
  },
  help: {
    shape: (
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1,15h-2V15h2Zm2.4-6.46a2.71,2.71,0,0,1-.44.75,2.92,2.92,0,0,1-.58.53l-.6.44a2.72,2.72,0,0,0-.5.5,1.63,1.63,0,0,0-.28.58L13,14H11.12v-.76a2.81,2.81,0,0,1,.68-1.58,3.56,3.56,0,0,1,.53-.5q.28-.21.52-.42a1.9,1.9,0,0,0,.39-.46,1.15,1.15,0,0,0,.13-.63,1.29,1.29,0,0,0-.32-1,1.21,1.21,0,0,0-.88-.31,1.37,1.37,0,0,0-.65.15,1.31,1.31,0,0,0-.45.39,1.72,1.72,0,0,0-.26.58,2.86,2.86,0,0,0-.08.71H8.66A4,4,0,0,1,8.92,8.8a3.31,3.31,0,0,1,.69-1.1A3.11,3.11,0,0,1,10.68,7a3.61,3.61,0,0,1,1.4-.26A4.41,4.41,0,0,1,13.74,7a3.24,3.24,0,0,1,1.08.68,2.44,2.44,0,0,1,.58.88,2.54,2.54,0,0,1,.18.88A3,3,0,0,1,15.4,10.55Z" />
    ),
  },
  highlight: {
    shape: (
      <g>
        <rect x="4" y="19" width="16" height="2" />
        <path
          d="M18.69,5.41a1,1,0,0,0,0-1.41L17,2.29a1,1,0,0,0-1.41,0L14.18,3.7l3,3.13Z"
          fillRule="evenodd"
        />
        <polygon
          points="16.17 7.82 13.14 4.68 4 13.97 4 17 6.97 17 16.17 7.82"
          fillRule="evenodd"
        />
      </g>
    ),
  },
  home: {
    shape: (
      <polygon points="20.92 12 11.94 3.02 2.96 12 5 12 5 21 10 21 10 14 14 14 14 21 19 21 19 12 20.92 12" />
    ),
  },
  info_outline: {
    shape: (
      <g>
        <path
          d="M12,2c-5.486,0 -10,4.514 -10,10c0,5.486 4.514,10 10,10c5.486,0 10,-4.514 10,-10c0,-5.486 -4.514,-10 -10,-10Zm0,18c-4.389,0 -8,-3.611 -8,-8c0,-4.389 3.611,-8 8,-8c4.389,0 8,3.611 8,8c0,4.389 -3.611,8 -8,8l0,0Z"
          fillRule="nonzero"
        />
        <rect height="7.253" width="2" x="11" y="9.747" />
        <rect height="2" width="2" x="11" y="6.747" />
      </g>
    ),
  },
  info: {
    shape: (
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1,14.85H11V11h2ZM13,9h-2v-2h2Z" />
    ),
  },
  item: {
    shape: (
      <g>
        <path d="M12.61,13.67H1.39A1.05,1.05,0,0,1,.33,12.61V1.39A1.05,1.05,0,0,1,1.39.33H12.61a1.05,1.05,0,0,1,1.06,1.06V12.61a1.05,1.05,0,0,1-1.06,1.06" />
        <polygon
          fill="#FFFFFF"
          points="3.49 4.54 10.51 4.54 10.51 3.84 3.49 3.84 3.49 4.54"
        />
        <polygon
          fill="#FFFFFF"
          points="3.49 6.3 10.51 6.3 10.51 5.6 3.49 5.6 3.49 6.3"
        />
        <polygon
          fill="#FFFFFF"
          points="3.49 8.05 10.51 8.05 10.51 7.35 3.49 7.35 3.49 8.05"
        />
        <polygon
          fill="#FFFFFF"
          points="3.49 9.81 9.11 9.81 9.11 9.11 3.49 9.11 3.49 9.81"
        />
      </g>
    ),
  },
  item_add: {
    shape: (
      <g>
        <path d="M5,5H17v7h2V4a1,1,0,0,0-1-1H4A1,1,0,0,0,3,4V18a1,1,0,0,0,1,1h8V17L5,17Z" />
        <polygon points="22 17 19 17 19 14 17 14 17 17 14 17 14 19 17 19 17 22 19 22 19 19 22 19 22 17" />
      </g>
    ),
  },
  item_copy: {
    shape: (
      <g>
        <path d="M18,17V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3V17a1,1,0,0,0,1,1H17A1,1,0,0,0,18,17Zm-2-1H4V4H16Z" />
        <path d="M21,7H20V20H6v1a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V8A1,1,0,0,0,21,7Z" />
      </g>
    ),
  },
  item_edit: {
    shape: (
      <g>
        <path d="M21.69,4,20,2.29a1,1,0,0,0-1.41,0L17.18,3.7l3,3.13,1.51-1.41A1,1,0,0,0,21.69,4Z" />
        <polygon points="8 16 10.97 16 19.17 7.82 16.14 4.68 8 12.97 8 16" />
        <path d="M19,19H5V5h5.92l2-2H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V11l-2,2Z" />
      </g>
    ),
  },
  item_remove: {
    shape: (
      <g>
        <path d="M5,5H17v7h2V4a1,1,0,0,0-1-1H4A1,1,0,0,0,3,4V18a1,1,0,0,0,1,1h8V17L5,17Z" />
        <polygon points="22.04 15.38 20.62 13.96 18 16.59 15.38 13.96 13.96 15.38 16.59 18 13.96 20.62 15.38 22.04 18 19.41 20.62 22.04 22.04 20.62 19.41 18 22.04 15.38" />
      </g>
    ),
  },
  label_off: {
    shape: (
      <g>
        <polygon points="12.56 15.58 15.48 15.58 17.36 21 20.03 21 16.61 11.54 12.56 15.58" />
        <path d="M20.52,2.06,15.13,7.46,13.51,3H10.76L5.43,17.16,1.92,20.67l1.41,1.41,18.6-18.6ZM12,5.66l1.26,3.63-4,4Z" />
      </g>
    ),
  },
  label_on: {
    shape: (
      <path d="M10.76,3h2.75L20,21H17.36l-1.88-5.44h-7L6.43,21H3.93Zm4,10.6L12,5.66,9.15,13.6Z" />
    ),
  },
  launch: {
    shape: (
      <path
        d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"
        fillRule="evenodd"
      />
    ),
  },
  link: {
    shape: (
      <g>
        <path d="M19.68,4.31a4.36,4.36,0,0,0-6.13,0L9.68,8.15a4.36,4.36,0,0,0,0,6.13l1.54-1.54a2.18,2.18,0,0,1,0-3l3.87-3.87A2.18,2.18,0,0,1,18.17,8.9L17,10.06a3.59,3.59,0,0,1,.27,2.81l2.44-2.44A4.36,4.36,0,0,0,19.68,4.31Z" />
        <path d="M12.75,11.24a2.18,2.18,0,0,1,0,3L8.91,18.16a2.18,2.18,0,0,1-3.08-3.08L7,13.92a3.59,3.59,0,0,1-.27-2.81L4.29,13.54a4.36,4.36,0,0,0,6.16,6.16l3.87-3.87a4.36,4.36,0,0,0,0-6.13Z" />
      </g>
    ),
  },
  iclicker: {
    shape: (
      <g>
        <defs>
          <linearGradient
            id="a"
            x1="41.91"
            y1="3.65"
            x2="41.91"
            y2="87.42"
            gradientTransform="matrix(1, 0, 0, -1, 1.3, 88.31)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#497df5" />
            <stop offset="1" stopColor="#1565c0" />
          </linearGradient>
        </defs>
        <circle cx="43.33" cy="42.65" r="42" fill="url(#a)" />
        <path
          d="M49.45,59.39l-19.64-.12a13.63,13.63,0,0,1,1.57-27.2,13.42,13.42,0,0,1,2.76.29,17.9,17.9,0,0,1,15.35-8.68c6,0,10.73,3.2,13.68,5.88a2.25,2.25,0,0,1-3,3.29c-2.37-2.19-6.14-4.71-10.67-4.71a13.39,13.39,0,0,0-12.13,7.78l-.87,1.89-2-.71a9.13,9.13,0,1,0-4.39,17.64l19.3.09c5.48,0,9.54-1.86,11.46-5.26a2.25,2.25,0,1,1,3.91,2.19C62.12,56.64,56.52,59.39,49.45,59.39Z"
          fill="#fff"
        />
        <path
          d="M67.53,42.14a2.86,2.86,0,1,0-3.91,1.1,2.86,2.86,0,0,0,3.91-1.1h0"
          fill="#fff"
        />
      </g>
    ),
  },
  iclicker_cloud: {
    shape: (
      <g>
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
            fill="url(#paint0_linear_689_829)"
          />
          <path
            d="M10.3108 12.5873L6.10797 12.5638C5.36693 12.4793 4.68621 12.1148 4.20523 11.5448C3.72425 10.9747 3.47941 10.2424 3.52084 9.49771C3.56228 8.75303 3.88687 8.05237 4.42812 7.53923C4.96937 7.02609 5.68633 6.73931 6.43216 6.73761C6.6312 6.73755 6.82967 6.75881 7.02418 6.80104C7.36537 6.23359 7.84755 5.76403 8.42386 5.43801C9.00016 5.11198 9.651 4.94057 10.3131 4.94043C11.5888 4.94043 12.6131 5.62641 13.2474 6.19963C13.3257 6.28896 13.3682 6.40409 13.3668 6.52289C13.3654 6.64169 13.3201 6.75577 13.2397 6.8432C13.1592 6.93064 13.0493 6.98525 12.931 6.99655C12.8128 7.00785 12.6945 6.97503 12.599 6.90441C12.0915 6.43456 11.2834 5.89423 10.3131 5.89423C9.76614 5.89583 9.23098 6.05367 8.77067 6.34917C8.31035 6.64467 7.94404 7.06553 7.71486 7.5622L7.51752 7.98741L7.1017 7.83471C6.84333 7.73941 6.56776 7.69966 6.29298 7.71803C6.0182 7.7364 5.75038 7.8125 5.50699 7.94135C5.2636 8.0702 5.05011 8.24891 4.88044 8.46583C4.71077 8.68274 4.58874 8.93299 4.5223 9.20025C4.45586 9.46751 4.4465 9.74577 4.49485 10.0169C4.54319 10.288 4.64814 10.5459 4.80287 10.7737C4.95759 11.0015 5.1586 11.1942 5.39278 11.3391C5.62697 11.484 5.88908 11.5779 6.162 11.6147L10.2967 11.6335C11.4713 11.6335 12.3405 11.2341 12.7517 10.5058C12.8181 10.4028 12.9213 10.3291 13.0402 10.2995C13.1591 10.27 13.2848 10.2868 13.3917 10.3467C13.4986 10.4066 13.5787 10.505 13.6156 10.6219C13.6525 10.7387 13.6435 10.8652 13.5903 10.9757C13.0265 11.9976 11.8261 12.5873 10.3108 12.5873Z"
            fill="white"
          />
          <path
            d="M14.1848 8.89205C14.2437 8.78629 14.2699 8.66547 14.2602 8.54482C14.2506 8.42416 14.2054 8.30908 14.1304 8.21406C14.0554 8.11904 13.954 8.04833 13.8389 8.01085C13.7238 7.97337 13.6002 7.97079 13.4837 8.00344C13.3671 8.03609 13.2628 8.1025 13.1839 8.19431C13.1051 8.28612 13.0551 8.39923 13.0404 8.51937C13.0257 8.63951 13.0469 8.76132 13.1013 8.86945C13.1557 8.97757 13.2409 9.06718 13.3461 9.12697C13.4166 9.16667 13.4942 9.19208 13.5745 9.20175C13.6548 9.21142 13.7363 9.20517 13.8142 9.18335C13.8921 9.16154 13.9649 9.12458 14.0285 9.07459C14.0921 9.02461 14.1452 8.96258 14.1848 8.89205Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_689_829"
              x1="9"
              y1="18"
              x2="9"
              y2="0"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#497DF5" />
              <stop offset="1" stopColor="#1565C0" />
            </linearGradient>
          </defs>
        </svg>
      </g>
    ),
  },
  unlink: {
    shape: (
      <g>
        <path
          className="cls-1"
          d="M12,14.83,8.46,18.36a2,2,0,0,1-2.82-2.82L9.17,12,7.76,10.59,4.22,14.12a4,4,0,0,0,5.66,5.66l3.53-3.54Z"
        />
        <path
          className="cls-1"
          d="M14.12,4.22,10.59,7.76,12,9.17l3.54-3.53a2,2,0,0,1,2.82,2.82L14.83,12l1.41,1.41,3.54-3.53a4,4,0,0,0-5.66-5.66Z"
        />
        <path
          className="cls-1"
          d="M5.28,5.28a.51.51,0,0,0,0,.71L7.4,8.11a.5.5,0,0,0,.71-.71L6,5.28A.51.51,0,0,0,5.28,5.28Z"
        />
        <path
          className="cls-1"
          d="M9.53,6.7a.51.51,0,0,0,.14-.36V3.51a.5.5,0,0,0-.5-.5.51.51,0,0,0-.5.5V6.34a.5.5,0,0,0,.5.5A.52.52,0,0,0,9.53,6.7Z"
        />
        <path
          className="cls-1"
          d="M3.51,8.67a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5H6.34a.51.51,0,0,0,.36-.14.52.52,0,0,0,.14-.36.5.5,0,0,0-.5-.5Z"
        />
        <path
          className="cls-1"
          d="M15.89,15.89a.5.5,0,0,0,0,.71L18,18.72a.5.5,0,1,0,.71-.71L16.6,15.89A.5.5,0,0,0,15.89,15.89Z"
        />
        <path
          className="cls-1"
          d="M17.66,14.33a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5h2.83a.51.51,0,0,0,.35-.15.49.49,0,0,0,.15-.35.5.5,0,0,0-.5-.5Z"
        />
        <path
          className="cls-1"
          d="M14.33,17.66v2.83a.5.5,0,0,0,.5.5.49.49,0,0,0,.35-.15.51.51,0,0,0,.15-.35V17.66a.5.5,0,0,0-.5-.5A.5.5,0,0,0,14.33,17.66Z"
        />
      </g>
    ),
  },
  list_left: {
    shape: (
      <g>
        <rect x="8" y="3" width="13" height="3" />
        <rect x="3" y="3" width="3" height="3" />
        <rect x="3" y="10" width="3" height="3" />
        <rect x="3" y="17" width="3" height="3" />
        <rect x="8" y="10" width="13" height="3" />
        <rect x="8" y="17" width="13" height="3" />
      </g>
    ),
  },
  list_numbered: {
    shape: (
      <g>
        <rect className="cls-1" x="8" y="3" width="13" height="3" />
        <rect className="cls-1" x="4" y="2" width="1" height="5" />
        <rect className="cls-1" x="8" y="10" width="13" height="3" />
        <rect className="cls-1" x="8" y="17" width="13" height="3" />
        <polygon
          className="cls-2"
          points="3 10 5 10 5 11 3 11 3 14 6 14 6 13 4 13 4 12 6 12 6 9 3 9 3 10"
        />
        <polygon
          className="cls-2"
          points="3 17 5 17 5 18 3 18 3 19 5 19 5 20 3 20 3 21 6 21 6 16 3 16 3 17"
        />
      </g>
    ),
  },
  list_right: {
    shape: (
      <g>
        <rect x="3" y="3" width="13" height="3" />
        <rect x="18" y="3" width="3" height="3" />
        <rect x="18" y="10" width="3" height="3" />
        <rect x="18" y="17" width="3" height="3" />
        <rect x="3" y="10" width="13" height="3" />
        <rect x="3" y="17" width="13" height="3" />
      </g>
    ),
  },
  loudspeaker: {
    shape: (
      <path d="M8 3H2C1.60218 3 1.22064 3.15804 0.93934 3.43934C0.658035 3.72064 0.5 4.10218 0.5 4.5V7.5C0.5 7.89783 0.658035 8.27936 0.93934 8.56066C1.22064 8.84196 1.60218 9 2 9H2.75V12C2.75 12.1989 2.82902 12.3897 2.96967 12.5303C3.11032 12.671 3.30109 12.75 3.5 12.75H5C5.19891 12.75 5.38968 12.671 5.53033 12.5303C5.67098 12.3897 5.75 12.1989 5.75 12V9H8L11.75 12V0L8 3ZM15.125 6C15.125 7.2825 14.405 8.445 13.25 9V3C14.3975 3.5625 15.125 4.725 15.125 6Z" />
    ),
    viewBox: '0 0 16 13',
  },
  lock: {
    shape: (
      <path d="M18,10H16V6A4,4,0,1,0,8,6v4H6a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V11A1,1,0,0,0,18,10ZM10,6a2,2,0,1,1,4,0v4H10Z" />
    ),
  },
  lock_circle: {
    shape: (
      <g
        id="CCM-12---Copy-to-Restricted-Access-Sections"
        stroke="none"
        strokeWidth="1"
      >
        <g
          id="TT---CCM-12---Course-Plan---Menu"
          transform="translate(-1162.000000, -601.000000)"
        >
          <g id="Group-2" transform="translate(1163.000000, 602.000000)">
            <circle
              id="Oval"
              strokeWidth="2"
              fill="#FFFFFF"
              cx="10"
              cy="10"
              r="10"
            />
            <g
              id="Icons-/-Status-&amp;-Alerts-/-lock"
              transform="translate(5.714286, 3.857143)"
            >
              <path
                d="M4.28571429,0.12244898 C5.52545918,0.12244898 6.53061224,1.12760204 6.53061224,2.36734694 L6.53061224,2.36734694 L6.53061224,4.6122449 L7.65306122,4.6122449 C7.96341837,4.6122449 8.21428571,4.86311224 8.21428571,5.17346939 L8.21428571,5.17346939 L8.21428571,10.7857143 C8.21428571,11.0960714 7.96341837,11.3469388 7.65306122,11.3469388 L7.65306122,11.3469388 L0.918367347,11.3469388 C0.608010204,11.3469388 0.357142857,11.0960714 0.357142857,10.7857143 L0.357142857,10.7857143 L0.357142857,5.17346939 C0.357142857,4.86311224 0.608010204,4.6122449 0.918367347,4.6122449 L0.918367347,4.6122449 L2.04081633,4.6122449 L2.04081633,2.36734694 C2.04081633,1.12760204 3.04596939,0.12244898 4.28571429,0.12244898 Z M4.28571429,1.24489796 C3.66612245,1.24489796 3.16326531,1.7477551 3.16326531,2.36734694 L3.16326531,2.36734694 L3.16326531,4.6122449 L5.40816327,4.6122449 L5.40816327,2.36734694 C5.40816327,1.7477551 4.90530612,1.24489796 4.28571429,1.24489796 Z"
                id="icon"
              />
            </g>
          </g>
        </g>
      </g>
    ),
  },
  lock_circle_ribbon: {
    shape: (
      <g
        id="CCM-12---Copy-to-Restricted-Access-Sections"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="TT---CCM-12---Course-Plan---Menu"
          transform="translate(-1162.000000, -601.000000)"
        >
          <g id="Group-2" transform="translate(1163.000000, 602.000000)">
            <circle
              id="Oval"
              stroke="#686868"
              strokeWidth="2"
              fill="none"
              cx="10"
              cy="10"
              r="10"
            />
            <g
              id="Icons-/-Status-&amp;-Alerts-/-lock"
              transform="translate(5.714286, 3.857143)"
              fill="#686868"
            >
              <path
                d="M4.28571429,0.12244898 C5.52545918,0.12244898 6.53061224,1.12760204 6.53061224,2.36734694 L6.53061224,2.36734694 L6.53061224,4.6122449 L7.65306122,4.6122449 C7.96341837,4.6122449 8.21428571,4.86311224 8.21428571,5.17346939 L8.21428571,5.17346939 L8.21428571,10.7857143 C8.21428571,11.0960714 7.96341837,11.3469388 7.65306122,11.3469388 L7.65306122,11.3469388 L0.918367347,11.3469388 C0.608010204,11.3469388 0.357142857,11.0960714 0.357142857,10.7857143 L0.357142857,10.7857143 L0.357142857,5.17346939 C0.357142857,4.86311224 0.608010204,4.6122449 0.918367347,4.6122449 L0.918367347,4.6122449 L2.04081633,4.6122449 L2.04081633,2.36734694 C2.04081633,1.12760204 3.04596939,0.12244898 4.28571429,0.12244898 Z M4.28571429,1.24489796 C3.66612245,1.24489796 3.16326531,1.7477551 3.16326531,2.36734694 L3.16326531,2.36734694 L3.16326531,4.6122449 L5.40816327,4.6122449 L5.40816327,2.36734694 C5.40816327,1.7477551 4.90530612,1.24489796 4.28571429,1.24489796 Z"
                id="icon"
              />
            </g>
          </g>
        </g>
      </g>
    ),
  },
  maximize: {
    shape: (
      <g>
        <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H5V5H19Z" />
        <polygon points="11 17 13 17 13 13 17 13 17 11 13 11 13 7 11 7 11 11 7 11 7 13 11 13 11 17" />
      </g>
    ),
  },
  menu: {
    shape: (
      <g>
        <rect x="3" y="3" width="18" height="3" />
        <rect x="3" y="10" width="18" height="3" />
        <rect x="3" y="17" width="18" height="3" />
      </g>
    ),
  },
  microphone: {
    shape: (
      <g>
        <rect
          x="9.14"
          y="2.97"
          width="5.72"
          height="11.18"
          rx="2.86"
          ry="2.86"
        />
        <path d="M19.08,11.15a1,1,0,1,0-2,0,5.05,5.05,0,1,1-10.11,0,1,1,0,0,0-2,0,7.1,7.1,0,0,0,6.06,7v2a1,1,0,0,0,2,0v-2A7.1,7.1,0,0,0,19.08,11.15Z" />
      </g>
    ),
  },
  minimize: {
    shape: (
      <g>
        <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H5V5H19Z" />
        <rect x="7" y="15" width="10" height="2" />
      </g>
    ),
  },
  minus: {
    shape: <rect x="3" y="11" width="18" height="2" />,
  },
  mobile_phone: {
    shape: (
      <path d="M16.54,2h-9A1.5,1.5,0,0,0,6,3.5v17A1.5,1.5,0,0,0,7.54,22h9A1.5,1.5,0,0,0,18,20.5V3.5A1.5,1.5,0,0,0,16.54,2ZM12,20.5a1,1,0,1,1,1-1A1,1,0,0,1,12,20.5ZM16,17H8V4h8Z" />
    ),
  },
  export: {
    shape: (
      <path d="M18.958 12L21 14V20C21 20.55 20.55 21 20 21H4C3.45 21 3 20.55 3 20V4C3 3.45 3.45 3 4 3H9.917L11.917 5H5V19H19L18.958 12ZM13.978 3H21V10.022L18.258 7.28L10.77 14.77L9.355 13.355L16.844 5.866L13.978 3Z" />
    ),
  },
  more: {
    shape: (
      <g>
        <circle cx="3.99" cy="12" r="1.96" />
        <circle cx="11.99" cy="12" r="1.96" />
        <circle cx="19.99" cy="12" r="1.96" />
      </g>
    ),
  },
  more_rotated: {
    shape: (
      <g>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
      </g>
    ),
  },
  mortar_board: {
    shape: (
      <g>
        <polygon points="12.36 9.24 6.2 13.18 12 16.89 24.02 9.22 12 1.54 -0.02 9.22 4.83 12.31 10.96 8.39 12.36 9.24" />
        <polygon points="4.99 14.09 4.99 17.41 12 22 19.01 17.41 19.01 14.09 12 18.65 4.99 14.09" />
      </g>
    ),
  },
  move: {
    shape: (
      <polygon
        points="22.05 12 19 8.95 19 11 13 11 13 5 15.05 5 12 1.95 8.95 5 11 5 11 11 5 11 5 8.95 1.95 12 5 15.05 5 13 11 13 11 19 8.95 19 12 22.05 15.05 19 13 19 13 13 19 13 19 15.05 22.05 12"
        fillRule="evenodd"
      />
    ),
  },
  not: {
    shape: (
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM4,12A8,8,0,0,1,16.82,5.66l-11.37,11A8,8,0,0,1,4,12Zm8,8A8,8,0,0,1,6.79,18.1l11.45-11A8,8,0,0,1,12,20Z" />
    ),
  },
  pause_solo: {
    shape: (
      <g>
        <rect x="5.04" y="3" width="5" height="18" />
        <rect x="14.04" y="3" width="5" height="18" />
      </g>
    ),
  },
  pause: {
    shape: (
      <g>
        <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
        <rect x="9" y="8" width="2" height="8" />
        <rect x="13" y="8" width="2" height="8" />
      </g>
    ),
  },
  person: {
    shape: (
      <g>
        <path d="M12,12.92c2.6,0,4.61-3,4.61-5.84S15.15,2,12,2,7.37,4.25,7.37,7.08,9.39,12.92,12,12.92Z" />
        <path d="M12,15.54c-5.31,0-9.65-4.2-9.93,5.41a1,1,0,0,0,1,1H20.92a1,1,0,0,0,1-1C21.63,11.37,17.29,15.54,12,15.54Z" />
      </g>
    ),
  },
  person_group: {
    shape: (
      <g>
        <path d="M11.37,7.49c0,2-1.42,4.12-3.25,4.12S4.87,9.49,4.87,7.49s1-3.61,3.25-3.61S11.37,5.49,11.37,7.49Z" />
        <path d="M14.42,19a.72.72,0,0,0,.7-.73c0-7.48-3.26-4.81-7-4.81s-7-2.7-7,4.81a.72.72,0,0,0,.7.73Z" />
        <path d="M19.5,8.64c0,1.62-1.15,3.34-2.64,3.34s-2.64-1.72-2.64-3.34.83-2.93,2.64-2.93S19.5,7,19.5,8.64Z" />
        <path d="M16.44,13.71c-.26,0-.51,0-.76,0A14.93,14.93,0,0,1,16.46,18a1.07,1.07,0,0,1-.55,1h6.46a.67.67,0,0,0,.66-.69C23,11,20,13.71,16.44,13.71Z" />
      </g>
    ),
  },
  play_solo: {
    shape: (
      <polygon
        points="6.04 21 20.36 11.99 6.04 3.06 6.04 21"
        fillRule="evenodd"
      />
    ),
  },
  play: {
    shape: (
      <g>
        <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
        <polygon
          points="9 17.03 16.98 12.01 9 7.03 9 17.03"
          fillRule="evenodd"
        />
      </g>
    ),
  },
  plus: {
    shape: (
      <polygon points="21 11 13 11 13 3 11 3 11 11 3 11 3 13 11 13 11 21 13 21 13 13 21 13 21 11" />
    ),
  },
  pointer_outline: {
    shape: (
      <path d="M8.95,6.56l6.92,6.34L13,13.57l2.28,5.1-1.65.71-2.28-5.22L9,16,8.95,6.56M6.92,2,7,20l3.51-2.73,2,4.69,5.34-2.31L15.81,15,20,14,6.92,2Z" />
    ),
  },
  pointer: {
    shape: (
      <path d="M6.92,2,7,20l3.51-2.73,2,4.69,5.34-2.31L15.81,15,20,14,6.92,2Z" />
    ),
  },
  print: {
    shape: (
      <g>
        <path d="M21,8H3A1,1,0,0,0,2,9v8a1,1,0,0,0,1,1H5v4H19V18h2a1,1,0,0,0,1-1V9A1,1,0,0,0,21,8ZM6,12H4V10H6Zm11,6v2H7V16H17Z" />
        <rect x="5.96" y="2.02" width="12.04" height="4.98" />
      </g>
    ),
  },
  refresh: {
    shape: (
      <path
        d="M4 12a8 8 0 0 1 13.44-5.85L14.57 9h7V2l-2.71 2.73A10 10 0 0 0 2 12zM22 12a10 10 0 0 1-16.84 7.3L2.48 22v-7h7l-2.87 2.89A8 8 0 0 0 20 12z"
        fillRule="evenodd"
      />
    ),
  },
  replay: {
    shape: (
      <path
        d="M20,12a8,8,0,1,1-2.59-5.87L14.57,9h7V2L18.86,4.73A10,10,0,1,0,22,12Z"
        fillRule="evenodd"
      />
    ),
  },
  search: {
    shape: (
      <path d="M16.35,14.94a8.08,8.08,0,1,0-1.43,1.4l5.37,5.37,1.41-1.41ZM10,16a6,6,0,1,1,6-6A6,6,0,0,1,10,16Z" />
    ),
  },
  sequence: {
    shape: (
      <g>
        <path d="M20.625,9 C19.9166667,9 19.3541667,9.58695652 19.3541667,10.326087 L19.3541667,14.8913043 C19.3541667,16.0434783 18.4583333,16.9782609 17.3541667,16.9782609 L7.91666667,16.9782609 L7.91666667,15.3043478 C7.91666667,14.7826087 7.35416667,14.5 6.95833333,14.8043478 L3.1875,17.8043478 C2.875,18.0434783 2.875,18.5434783 3.1875,18.8043478 L6.95833333,21.7826087 C7.35416667,22.0869565 7.91666667,21.8043478 7.91666667,21.2826087 L7.91666667,19.6086957 L17.375,19.6086957 C19.875,19.6086957 21.9166667,17.4782609 21.9166667,14.8695652 L21.9166667,10.3043478 C21.8958333,9.58695652 21.3333333,9 20.625,9 Z" />
        <path d="M4.625,13.673913 L4.625,9.10869565 C4.625,7.95652174 5.52083333,7.02173913 6.625,7.02173913 L16.0833333,7.02173913 L16.0833333,8.69565217 C16.0833333,9.2173913 16.6458333,9.5 17.0416667,9.19565217 L20.8125,6.19565217 C21.125,5.95652174 21.125,5.45652174 20.8125,5.19565217 L17.0416667,2.2173913 C16.6458333,1.91304348 16.0833333,2.19565217 16.0833333,2.7173913 L16.0833333,4.39130435 L6.64583333,4.39130435 C4.14583333,4.39130435 2.10416667,6.52173913 2.10416667,9.13043478 L2.10416667,13.6956522 C2.10416667,14.4347826 2.66666667,15.0217391 3.375,15.0217391 C4.08333333,15.0217391 4.625,14.4130435 4.625,13.673913 Z" />
      </g>
    ),
  },
  sign_out: {
    shape: (
      <g>
        <polygon points="3 3 3 21 21 21 21 16 19 16 19 19 5 19 5 5 19 5 19 8 21 8 21 3 3 3" />
        <polygon points="20 12 16 8 16 11 9 11 9 13 16 13 16 16 20 12" />
      </g>
    ),
  },
  spreadsheet: {
    shape: (
      <g>
        <path d="M18,4V20H6V4H18m1-2H5A1,1,0,0,0,4,3V21a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1Z" />
        <path d="M8,7V17h8V7Zm6,2v2H10V9Zm-4,6V13h4v2Z" />
      </g>
    ),
  },
  assignment: {
    shape: (
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Icons-/-Content-Types-/-document_pencil"
          transform="translate(-4.000000, -2.000000)"
          fill="#686868"
        >
          <path
            d="M19.0899,14.9903 L20.9809,16.9403 L15.8799,22.0303 L14.0299,22.0303 L14.0299,20.1503 L19.0899,14.9903 Z M19,2 C19.5135,2 19.935602,2.38542347 19.9932824,2.88324672 L20,3 L20,11 L18,13 L18,4 L6,4 L6,20 L12,20 L12,22 L5,22 C4.4865,22 4.06439796,21.6145765 4.00671757,21.1167533 L4,21 L4,3 C4,2.4865 4.38542347,2.06439796 4.88324672,2.00671757 L5,2 L19,2 Z M14.04,15 L14.04,17 L8.04,17 L8.04,15 L14.04,15 Z M21.4972,13.4969 L21.5002,13.4999 L22.5002,14.5699 C22.7432,14.8119 22.7442,15.2039 22.5032,15.4469 L22.5002,15.4499 L21.5592,16.3299 L20.6202,13.4999 C20.8612,13.2569 21.2542,13.2559 21.4972,13.4969 Z M16.04,11 L16.04,13 L8.04,13 L8.04,11 L16.04,11 Z M16.04,7 L16.04,9 L8.04,9 L8.04,7 L16.04,7 Z"
            id="icon"
          />
        </g>
      </g>
    ),
  },
  learning_objective: {
    shape: (
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Icons-/-Content-Types-/-head"
          transform="translate(-4.000000, -2.000000)"
          fill="#686868"
        >
          <path
            d="M11.77,2.0005 C15.82,2.0005 19.11,5.0005 19.11,8.7905 C19.108,9.2645 19.051,9.7385 18.94,10.2005 C18.868,10.4725 18.916,10.7635 19.07,11.0005 L19.07,11.0005 L20.6,13.3205 C20.668,13.4305 20.714,13.5525 20.734,13.6805 C20.824,14.2255 20.455,14.7405 19.91,14.8305 L19.91,14.8305 L19.72,14.8305 C19.313,14.9215 19.007,15.2565 18.95,15.6695 C18.77,16.9195 18.31,19.4805 17.47,19.7505 C15.7,20.2995 13.5,18.5995 13.7,20.7505 C13.707,20.7995 13.71,20.8495 13.71,20.9005 C13.704,21.4525 13.252,21.8955 12.7,21.8895602 L12.7,21.8895602 L8.03,21.8895602 C7.478,21.8895602 7.03,21.4425 7.03,20.8895 C7.112,19.7925 7.112,18.6885 7.03,17.5895 C6.57,14.8795 4.43,12.4005 4.43,9.1295 L4.43,9.1295 L4.43,8.7695 C4.43,5.0005 7.72,2.0005 11.77,2.0005 Z M11.7,4.2305 C8.96,4.2305 6.7,5.8395 6.7,8.2305 C6.7,10.6205 8.92,12.5595 11.7,12.5595 C14.48,12.5595 13.49,10.5305 16,8.2305 C17.79,6.6205 14.44,4.2305 11.7,4.2305 Z"
            id="icon"
          />
        </g>
      </g>
    ),
  },
  spreadsheet_revised: {
    shape: (
      <g>
        <path d="M19,2H5A1,1,0,0,0,4,3V21a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V3A1,1,0,0,0,19,2ZM18,20H6V4H18Z" />
        <path d="M17,7H7.1v9.94H17Zm-2,4.13H13V9H15ZM11,9v2.13H9.1V9ZM9.1,12.94H11v2H9.1Zm3.94,2v-2H15v2Z" />
      </g>
    ),
  },
  star: {
    shape: (
      <g transform="translate(2,3)">
        <path d="M9.99999 0L7.07899 5.985L0.493988 6.951L5.22999 11.615L4.07599 18.109L9.97299 15L15.847 18.12L14.75 11.564L19.534 6.949L12.969 6.016L9.99999 0Z" />
      </g>
    ),
  },
  stop_solo: {
    shape: (
      <g>
        <rect x="3.04" y="3" width="18" height="18" />
      </g>
    ),
  },
  stop: {
    shape: (
      <g>
        <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" />
        <rect x="8" y="8" width="8" height="8" />
      </g>
    ),
  },
  suitcase: {
    shape: (
      <g>
        <path d="M16,6V3a1,1,0,0,0-1-1H9A1,1,0,0,0,8,3V6H6V20H18V6ZM10,4h4V6H10Z" />
        <path d="M5,6H3A1,1,0,0,0,2,7V19a1,1,0,0,0,1,1H5Z" />
        <path d="M21,6H19V20h2a1,1,0,0,0,1-1V7A1,1,0,0,0,21,6Z" />
      </g>
    ),
  },
  text_size: {
    shape: (
      <g>
        <polygon
          points="21 4 10 4 10 7 14 7 14 20 17 20 17 7 21 7 21 4"
          fillRule="evenodd"
        />
        <polygon
          points="3 14 6 14 6 20 9 20 9 14 12 14 12 11 3 11 3 14"
          fillRule="evenodd"
        />
      </g>
    ),
  },
  thumbs_down: {
    shape: (
      <g>
        <path d="M22.08,13.11a1,1,0,0,1-1,1.12H14s1,2.8,1.62,4.59c.53,1.58-.23,2.93-1.31,1.85C12.7,19.12,8.5,14.59,8.5,14.59A1.71,1.71,0,0,1,8,13.36V3.53a.38.38,0,0,1,.38-.38H18.62a1.74,1.74,0,0,1,1.61,1.07s1.86,6.59,1.86,6.82Z" />
        <rect x="3" y="3.22" width="3" height="11" />
      </g>
    ),
  },
  thumbs_up: {
    shape: (
      <g>
        <path d="M22.08,11.1a1,1,0,0,0-1-1.12H14s1-2.8,1.62-4.59c.53-1.58-.23-2.93-1.31-1.85C12.7,5.1,8.5,9.62,8.5,9.62A1.71,1.71,0,0,0,8,10.86v9.83a.38.38,0,0,0,.38.38H18.62A1.74,1.74,0,0,0,20.23,20s1.86-6.59,1.86-6.82Z" />
        <rect x="3" y="10" width="3" height="11" />
      </g>
    ),
  },
  tools: {
    shape: (
      <g>
        <path d="M20.74,6.41a1,1,0,0,0,0-1.41L19,3.29a1,1,0,0,0-1.41,0L16.22,4.7l3,3.13Z" />
        <polygon points="3.04 17.98 3.04 21 6.01 21 10.9 16.12 7.87 13.09 3.04 17.98" />
        <polygon points="18.21 8.82 15.18 5.68 13.05 7.84 16.12 10.91 18.21 8.82" />
        <path d="M10.55,7.47A3.75,3.75,0,0,0,5.71,3.26L7.14,4.68A1.74,1.74,0,1,1,4.68,7.14L3.26,5.72a3.75,3.75,0,0,0,4.21,4.84l9.72,9.72a2.18,2.18,0,0,0,3.09-3.09Zm8.65,11.74a.76.76,0,1,1,0-1.08A.76.76,0,0,1,19.21,19.21Z" />
      </g>
    ),
  },
  trash: {
    shape: (
      <g>
        <path d="M6,21a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V7H6Z" />
        <path d="M18,3H14V2H9.92V3H6A1,1,0,0,0,5,4V6H19V4A1,1,0,0,0,18,3Z" />
      </g>
    ),
  },
  trash_hollow: {
    shape: (
      <g>
        <path d="M9 8H11V18H9V8Z" fill="#00758E" />
        <path d="M15 18V8H13V18H15Z" fill="#00758E" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 3H14V2H9.92V3H5C4.448 3 4 3.448 4 4V6H5V20.9333C5 21.5232 5.448 22 6 22H18C18.552 22 19 21.5232 19 20.9333V6H20V4C20 3.448 19.552 3 19 3ZM17 6H7V20H17V6Z"
          fill="#00758E"
        />
      </g>
    ),
  },
  trending: {
    shape: (
      <g>
        <path
          d="M21.908,9.6l-8.15,7.853l-3.921,-3.853l-1.916,-1.88l-5.986,5.986l-1.865,-1.865l7.833,-7.833l3.781,3.71l2.092,2.055l6.302,-6.072l1.83,1.899Z"
          id="Path"
        />
        <path d="M16.035,5.697l7.912,0l0,7.912l-7.912,-7.912Z" id="Rectangle" />
      </g>
    ),
  },
  trophy: {
    shape: (
      <path d="M20.539 5H18.556C18.587 4.452 18.607 3.61 18.607 3H7.12205C7.12205 3.609 7.13905 4.454 7.17005 5H5.18905C4.94505 5 4.74805 5.197 4.74805 5.441C4.74805 8.619 6.62005 10.026 8.52905 10.913C9.46105 12.87 11.084 13.754 11.989 14.154V15.607H10.181V16.528H9.27905V19.233H8.39605V21H17.415V19.233H16.475V16.528H15.611V15.607H13.793V14.14C14.695 13.732 16.255 12.841 17.185 10.903C19.1 10.014 20.981 8.608 20.981 5.441C20.981 5.197 20.783 5 20.539 5ZM17.733 9.42L17.7767 9.28991C18.1151 8.28337 18.3491 7.58733 18.491 6.042H19.933C19.821 7.775 19.166 8.483 17.733 9.42ZM7.23305 6.042H5.83105C5.94205 7.785 6.62005 8.497 8.05005 9.433C7.99565 9.26951 7.94237 9.115 7.89062 8.96489C7.59983 8.12153 7.35699 7.41722 7.23305 6.042Z" />
    ),
  },
  unlock: {
    shape: (
      <g>
        <path d="M18,10H10V6a2,2,0,1,1,4,0V7h2V6A4,4,0,1,0,8,6v4H6a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V11A1,1,0,0,0,18,10Z" />
      </g>
    ),
  },
  upload: {
    shape: (
      <g>
        <polygon
          points="19 14 19 18 5 18 5 14 3 14 3 18 3 20 5.5 20 19.5 20 21 20 21 18 21 14 19 14"
          fillRule="evenodd"
        />
        <polygon
          points="11 15 13 15 13 8 16 8 12 4 8 8 11 8 11 15"
          fillRule="evenodd"
        />
      </g>
    ),
  },
  video: {
    shape: (
      <g>
        <polygon points="9 7.63 9 16.37 15.97 11.98 9 7.63" />
        <path d="M20,3H4A1,1,0,0,0,3,4V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V4A1,1,0,0,0,20,3ZM19,19H5V5H19Z" />
      </g>
    ),
  },
  visibility: {
    shape: (
      <g>
        <path d="M6.5,7.5C4,7.5,2,9.5,2,12s2,4.5,4.5,4.5s4.5-2,4.5-4.5C11,9.5,9,7.5,6.5,7.5C6.5,7.5,6.5,7.5,6.5,7.5z M6.5,14.5 C5.1,14.5,4,13.4,4,12s1.1-2.5,2.5-2.5S9,10.6,9,12S7.9,14.5,6.5,14.5z" />
        <path d="M17.5,7.5C15,7.5,13,9.5,13,12s2,4.5,4.5,4.5s4.5-2,4.5-4.5C22,9.5,20,7.5,17.5,7.5C17.5,7.5,17.5,7.5,17.5,7.5z M17.5,14.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5S20,10.6,20,12S18.9,14.5,17.5,14.5z" />
        <path d="M12,10.5c2,0,2,1,2,1v2c0,0,0-1-2-1s-2,1-2,1v-2C10,11.5,10,10.5,12,10.5z" />
      </g>
    ),
  },
  warning: {
    shape: (
      <path
        d="M11,10 L13,10 L13,14 L11,14 L11,10 Z M11,15 L13,15 L13,17 L11,17 L11,15 Z M21.71,19.13 L13.06,3.85 C12.8696074,3.42238989 12.4655241,3.12885763 12,3.08 C11.5270612,3.12198251 11.1138588,3.41658051 10.92,3.85 L2.26,19.13 C1.67,20.13 2.15,21 3.34,21 L20.63,21 C21.82,21 22.3,20.15 21.71,19.13 Z M4.63,19 L12,6 L19.35,19 L4.63,19 Z"
        id="path-1"
      />
    ),
  },
  x: {
    shape: (
      <polygon points="19.82 5.59 18.41 4.18 12 10.59 5.59 4.18 4.18 5.59 10.59 12 4.18 18.41 5.59 19.82 12 13.41 18.41 19.82 19.82 18.41 13.41 12 19.82 5.59" />
    ),
  },
  zoom_in: {
    shape: (
      <g>
        <path d="M10,1.92a8,8,0,1,0,4.88,14.42l5.37,5.37,1.41-1.41-5.35-5.35A8,8,0,0,0,10,1.92ZM10,16a6,6,0,1,1,6-6,6,6,0,0,1-6,6Z" />
        <polygon points="11 6.13 8.92 6.13 8.92 8.92 6.13 8.92 6.13 11 8.92 11 8.92 13.79 11 13.79 11 11 13.79 11 13.79 8.92 11 8.92 11 6.13 11 6.13" />
      </g>
    ),
  },
  zoom_out: {
    shape: (
      <g>
        <path d="M10,1.92a8,8,0,1,0,4.88,14.42l5.37,5.37,1.41-1.41-5.35-5.35A8,8,0,0,0,10,1.92ZM10,16a6,6,0,1,1,6-6,6,6,0,0,1-6,6Z" />
        <polygon points="13.79 8.92 6.13 8.92 6.13 11 13.79 11 13.79 8.92 13.79 8.92" />
      </g>
    ),
  },
  writing_assignment: {
    shape: (
      <g
        id="S19-FINAL----Integrations-Phase-II"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="WritingActivity-II_CustomHidden_02"
          transform="translate(-357.000000, -95.000000)"
          fill="#A83D0E"
          fillRule="nonzero"
        >
          <g id="Writing" transform="translate(313.000000, 91.000000)">
            <g transform="translate(41.000000, 4.000000)">
              <path
                d="M0.408059211,28.0784539 L3.69753289,28.0784539 L0.408059211,28.0784539 Z"
                id="Fill-3"
              />
              <path
                d="M11.0949013,40.0965461 C8.13273026,40.0965461 4.98305921,39.5883224 3.29226974,39.2692434 L5.67055921,36.8975329 C7.61628289,37.2824013 9.21003289,37.4616776 10.6705592,37.4616776 C11.7248355,37.4616776 12.7297697,37.3679276 13.8333882,37.1705592 L14.6113487,36.8465461 L14.0011513,36.3465461 C13.0307566,35.5504934 11.5208882,34.5307566 10.4189145,33.7840461 C6.39753289,31.0636513 3.23470395,28.9205592 3.61299342,26.4847039 C3.79391447,25.3416118 4.72648026,24.4912829 6.31529605,24.0258224 C7.03404605,23.8136513 7.91891447,23.7067434 8.94523026,23.7067434 C11.8925987,23.7067434 15.6837171,24.5652961 19.3481908,25.3975329 C23.2708882,26.2824013 25.8893092,26.7379934 27.1442434,26.7560855 L27.759375,26.7626645 L27.4715461,26.2199013 C27.1722039,25.6541118 25.759375,24.2001645 23.4797697,21.8777961 L22.2972039,20.6672697 L25.5307566,20.6672697 L26.2988487,21.4567434 C30.4008224,25.6754934 31.2396382,26.6212171 30.3465461,28.2100329 C29.7840461,29.2133224 28.7560855,29.6590461 27.0126645,29.6590461 C24.9616776,29.6590461 22.2067434,29.0356908 18.7182566,28.2445724 C15.5225329,27.5208882 11.5455592,26.6195724 8.91233553,26.6195724 C8.18865132,26.6195724 7.60805921,26.6853618 7.14095395,26.821875 L6.58667763,26.9814145 L6.90082237,27.4353618 C7.87450658,28.5373355 10.4814145,30.3037829 12.0373355,31.3580592 C15.821875,33.9205592 17.790625,35.3300987 17.8449013,37.0488487 C17.8646382,37.7248355 17.5537829,38.3613487 16.9929276,38.7939145 C15.8662829,39.6590461 13.8810855,40.0965461 11.0949013,40.0965461"
                id="Fill-4"
              />
              <path
                d="M31.6935855,2.55246711 L33.4830592,0.762993421 C33.9764803,0.269572368 34.7774671,0.269572368 35.2725329,0.762993421 L37.4074013,2.93240132 C37.9008224,3.42582237 37.9008224,4.22680921 37.4074013,4.721875 L35.4912829,6.51134868"
                id="Fill-6"
              />
              <polygon
                id="Fill-8"
                points="23.8365132 17.9324013 20.0799342 17.9324013 20.0799342 14.1050987 30.3809211 3.61332237 34.2164474 7.57878289"
              />
            </g>
          </g>
        </g>
      </g>
    ),
  },
  assessment_assignment: {
    shape: (
      <g
        id="S19-FINAL----Integrations-Phase-II"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="WritingActivity-II_CustomHidden_02"
          transform="translate(-120.000000, -98.000000)"
          fill="#3B822E"
          fillRule="nonzero"
        >
          <g id="Group" transform="translate(73.000000, 91.000000)">
            <g
              id="Product-/-Assessment"
              transform="translate(47.000000, 6.000000)"
            >
              <g id="Assessment" transform="translate(0.000000, 0.750000)">
                <polygon
                  id="Shape"
                  points="27.8789063 18.3695652 25.5058594 16.1684783 9.86132813 30.5326087 2.70703125 23.8967391 0.24609375 26.1793478 9.84375 35.1304348 9.87890625 35.1141304 9.9140625 35.1304348"
                />
                <polygon
                  id="Shape"
                  points="27.8789063 2.47282609 25.5058594 0.27173913 9.86132813 14.6195652 2.70703125 8 0.24609375 10.2826087 9.84375 19.2336957 9.87890625 19.201087 9.9140625 19.2336957"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    ),
  },
  side_arrow: {
    shape: (
      <path
        d="M0 0h1.8v6.405h4.132L4.136 4.584l1.138-1.152L9 7.216 5.274 11 4.136 9.849l1.796-1.822H0z"
        fill="#00758E"
      />
    ),
  },
  adaptive_quiz: {
    shape: (
      <path
        d="M19,2 C19.553,2 20,2.447 20,3 L20,3 L20,13 L18,15 L18,4 L6,4 L6,20 L13,20 L15,22 L5,22 C4.447,22 4,21.553 4,21 L4,21 L4,3 C4,2.447 4.447,2 5,2 L5,2 Z M22.7059632,13 L24,14.232 L22.4288197,15.6385316 L20.4053007,17.45 L16.8106013,20.668 L16.4613077,21 L16.4516815,20.9906667 L16.4434304,21 L15.1480185,19.768 L15.1576447,19.76 L13,17.7066667 L14.303663,16.476 L16.4888111,18.564 L21.3509287,14.2126793 L22.7059632,13 Z M12.04,15 L12.04,17 L8.04,17 L8.04,15 L12.04,15 Z M16.04,11 L16.04,13 L8.04,13 L8.04,11 L16.04,11 Z M16.04,7 L16.04,9 L8.04,9 L8.04,7 L16.04,7 Z"
        fill="#080808"
      />
    ),
  },
  multi_drafts: {
    shape: (
      <g
        id='FE-270:-Updates-to-"My-Course"'
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="activity-types-4"
          transform="translate(-272.000000, -240.000000)"
          fill="#080808"
        >
          <g id="Group" transform="translate(78.000000, 152.000000)">
            <g id="folder-copy-2" transform="translate(194.000000, 88.000000)">
              <g id="Icons-/-Navigation-/-folder">
                <path
                  d="M20.0899,16.9903 L21.9809,18.9403 L16.8799,24.0303 L15.0299,24.0303 L15.0299,22.1503 L20.0899,16.9903 Z M20,4 C20.553,4 21,4.447 21,5 L21,5 L21,13 L19,15 L19,6 L7,6 L7,22 L13,22 L13,24 L6,24 C5.447,24 5,23.553 5,23 L5,23 L5,20 L1,20 C0.447,20 0,19.553 0,19 L0,19 L0,1 C0,0.447 0.447,0 1,0 L1,0 L15,0 C15.553,0 16,0.447 16,1 L16,1 L16,4 Z M15.04,17 L15.04,19 L9.04,19 L9.04,17 L15.04,17 Z M22.4972,15.4969 L22.5002,15.4999 L23.5002,16.5699 C23.7432,16.8119 23.7442,17.2039 23.5032,17.4469 L23.5002,17.4499 L22.5592,18.3299 L20.7402,16.3799 L21.6202,15.4999 C21.8612,15.2569 22.2542,15.2559 22.4972,15.4969 Z M17.04,13 L17.04,15 L9.04,15 L9.04,13 L17.04,13 Z M17.04,9 L17.04,11 L9.04,11 L9.04,9 L17.04,9 Z M14,2 L2,2 L2,18 L5,18 L5,5 C5,4.447 5.447,4 6,4 L6,4 L14,4 L14,2 Z"
                  id="icon"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    ),
  },
  interactive: {
    shape: (
      <g>
        <path
          d="M20 12V3C20 2.448 19.552 2 19 2H4C3.448 2 3 2.448 3 3V17C3 17.553 3.448 18 4 18H8V16H5V4H18V10L20 12Z"
          fill="#686868"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0673 21.3118L10 6.17432L20.9999 16.266L17.4762 17.1069L19.1918 21.0174L14.701 22.9601L13.0191 19.0159L10.0673 21.3118ZM17.5267 15.341L11.7072 10.0093L11.7492 17.948L13.7255 16.4007L15.6429 20.7905L17.0305 20.1934L15.1131 15.9045L17.5267 15.341Z"
          fill="#686868"
        />
      </g>
    ),
  },
  in_class: {
    shape: (
      <g
        id='FE-270:-Updates-to-"My-Course"'
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="activity-types-4"
          transform="translate(-80.000000, -244.000000)"
          fillRule="nonzero"
        >
          <g id="Group" transform="translate(78.000000, 152.000000)">
            <g id="in-class" transform="translate(0.000000, 90.000000)">
              <g id="Icons-/-Navigation-/-folder-Copy-12">
                <g id="presentation">
                  <polygon id="Path" points="0 0 24 0 24 24 0 24" />
                  <path
                    d="M3,2 C2.44772,2 2,2.44772 2,3 C2,3.55228 2.44772,4 3,4 L21,4 C21.5523,4 22,3.55228 22,3 C22,2.44772 21.5523,2 21,2 L3,2 Z"
                    id="Path"
                    fill="#080808"
                  />
                  <path
                    d="M3,15 L3,5 L5,5 L5,14 L19,14 L19,5 L21,5 L21,15 C21,15.5523 20.5523,16 20,16 L4,16 C3.44772,16 3,15.5523 3,15 Z"
                    id="Path"
                    fill="#080808"
                  />
                  <path
                    d="M7,22 L17,22 C17,20.8954 16.1046,20 15,20 L13,20 L13,17 L11,17 L11,20 L9,20 C7.89543,20 7,20.8954 7,22 Z"
                    id="Path"
                    fill="#080808"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    ),
  },
  sorter_caret_up: {
    shape: (
      <g>
        <path
          d="M18 15C18 16.6569 16.6569 18 15 18L3 18C1.34315 18 -1.17422e-07 16.6569 -2.62268e-07 15L-1.31134e-06 3C-1.45619e-06 1.34315 1.34314 1.45619e-06 3 1.31134e-06L15 2.62268e-07C16.6569 1.17422e-07 18 1.34315 18 3L18 15Z"
          fill="#686868"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.0325 12L8.99997 6.0015L3.93747 12L14.0325 12Z"
          fill="white"
        />
      </g>
    ),
  },
  sorter_caret_down: {
    shape: (
      <g>
        <path
          d="M0 3C0 1.34315 1.34315 0 3 0H15C16.6569 0 18 1.34315 18 3V15C18 16.6569 16.6569 18 15 18H3C1.34315 18 0 16.6569 0 15V3Z"
          fill="#686868"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.96753 6L9.00003 11.9985L14.0625 6H3.96753Z"
          fill="white"
        />
      </g>
    ),
  },
  sorter_caret_up_down: {
    shape: (
      <g>
        <path
          d="M0 3C0 1.34315 1.34315 0 3 0H15C16.6569 0 18 1.34315 18 3V15C18 16.6569 16.6569 18 15 18H3C1.34315 18 0 16.6569 0 15V3Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.0004 1.50024L14.0479 7.50174H3.95215L9.0004 1.50024ZM8.99965 16.5003L3.95215 10.5011H14.0479L8.99965 16.5003Z"
          fill="#686868"
        />
      </g>
    ),
  },
  category_order_chevron_up: {
    shape: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0.5L0.225 6.275L1.05333 7.10333L6 2.15083L10.9467 7.10333L11.775 6.275L6 0.5Z"
        fill="currentColor"
      />
    ),
  },
  category_order_chevron_down: {
    shape: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9526 0.896729L6.00012 5.84923L1.05287 0.896729L0.224533 1.72506L6.00012 7.50006L11.7751 1.72506L10.9526 0.896729Z"
        fill="currentColor"
      />
    ),
  },
  crossed_arrows: {
    shape: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 7L17 3V5.462C12.474 5.762 10.649 8.725 9.147 11.164L9.14563 11.1662C7.65428 13.5872 6.47594 15.5 3 15.5V18.5C8.152 18.5 10.12 15.305 11.701 12.737C13.101 10.467 14.181 8.734 17 8.475V11L22 7ZM3 8.5C5.336 8.5 6.629 9.375 7.683 10.677C7.71712 10.6212 7.74978 10.5692 7.78303 10.5163L7.78309 10.5162C7.81122 10.4715 7.83977 10.426 7.87 10.377L7.87498 10.3689C8.30874 9.66492 8.7973 8.872 9.397 8.089C7.997 6.633 6.064 5.5 3 5.5V8.5ZM17 13L22 17L17 21V18.526C14.365 18.348 12.64 17.277 11.368 15.924C11.994 15.113 12.513 14.28 12.979 13.523C13.017 13.462 13.053 13.404 13.09 13.344C14.026 14.538 15.135 15.354 17 15.525V13Z"
        fill="#686868"
      />
    ),
  },
  stack_checked: {
    shape: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8672 8V5H16.8672V2H2.86719V16H5.86719V19H8.86719V22H22.8672V8H19.8672ZM4.86719 14H14.8672V4H4.86719V14ZM7.43669 11.0702L7.42969 11.0762L8.37169 12.0002L8.37769 11.9932L8.38469 12.0002L8.63869 11.7512L13.8667 6.9242L12.9257 6.0002L8.40469 10.1732L6.81569 8.6072L5.86769 9.5302L7.43669 11.0702ZM20.8672 20H10.8672V19H19.8672V10H20.8672V20ZM7.86719 16V17H17.8672V7H16.8672V16H7.86719Z"
        fill="#686868"
      />
    ),
    viewBox: '0 0 25 24',
  },
  external_link: {
    shape: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.958 12L21 14V20C21 20.55 20.55 21 20 21H4C3.45 21 3 20.55 3 20V4C3 3.45 3.45 3 4 3H9.917L11.917 5H5V19H19L18.958 12ZM13.978 3H21V10.022L18.258 7.28L10.77 14.77L9.355 13.355L16.844 5.866L13.978 3Z"
      />
    ),
  },
};

export default iconShapes;
